import { FC, ReactNode } from 'react';
import usePermissionsKeys from 'app/hooks/usePermissionsKeys';
import { Navigate, useLocation } from 'react-router-dom';
import { evaluateRouteAccess } from 'app/config/routeAccessPolicies';

interface Props {
  children: ReactNode;
}

const RouteAccessGuard: FC<Props> = ({ children }) => {
  const { pathname } = useLocation();
  const permissionsKeys = usePermissionsKeys();

  const { allowed, redirectTo } = evaluateRouteAccess(
    pathname,
    permissionsKeys,
  );

  if (!allowed && redirectTo) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default RouteAccessGuard;
